import apiClient from './client';
import type {
  ValidateIdentityResponse,
  EffectivePermissions,
  GameDayStatusResponse,
  LandingPageData,
} from '@/types';

export async function validateIdentity(): Promise<ValidateIdentityResponse> {
  const response = await apiClient.get<ValidateIdentityResponse>('/api/auth/validate-identity');
  return response.data;
}

export async function getEffectivePermissions(): Promise<EffectivePermissions> {
  const response = await apiClient.get<EffectivePermissions>('/api/auth/effective-permissions');
  return response.data;
}

export async function getGameDayStatus(): Promise<GameDayStatusResponse> {
  const response = await apiClient.get<GameDayStatusResponse>('/api/auth/game-day-status');
  return response.data;
}

export async function getHomeData(): Promise<LandingPageData> {
  const response = await apiClient.get<LandingPageData>('/api/auth/home-data');
  return response.data;
}

export async function escalate(payload: {
  username: string;
  password: string;
  requiredRole: string;
  permissionCode: string;
  originalAction: { method: string; path: string };
}): Promise<{ token: string }> {
  const response = await apiClient.post<{ token: string }>('/api/auth/escalate', payload);
  return response.data;
}
